import React, { FC } from 'react';
import styled from 'styled-components';
import { Label } from './Label';

export interface ILabelledControlProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
    variant: components.ControlVariant;
    caption: string;
}

export const LabelledControl: FC<ILabelledControlProps> = ({ variant, children, ...props }) => (
    <StyledWrapper variant={variant}>
        <Label {...props} />
        {children}
    </StyledWrapper>
);

const StyledWrapper = styled.div<{ variant: components.ControlVariant }>`
    display: grid;
    gap: 4px;
    align-items: center;

    ${(props) =>
        props.variant === 'Rows'
            ? `grid-template-rows: auto;`
            : props.variant === 'Columns'
            ? `grid-template-columns: 165px auto;`
            : `grid-template-columns: 85px auto;`}
`;
